export const SET_SESSIONS = 'SET_SESSIONS';
export const SET_SESSION = 'SET_SESSION';
export const SET_SESSIONS_ANSWERS = 'SET_SESSIONS_ANSWERS';
export const SET_SESSIONS_QUESTIONS = 'SET_SESSIONS_QUESTIONS';
export const SET_SESSIONS_CURRENT_QUESTIONS = 'SET_SESSIONS_CURRENT_QUESTIONS';
export const SET_ERRORS = 'SET_ERRORS';
